export const RISK_TYPES = {
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3,
};

export const ROWS = [8, 9, 10, 11, 12, 13, 14, 15, 16];
